import "gantt-task-react/dist/index.css";

import React from "react";
import { ViewMode } from "gantt-task-react";
import { t } from "i18next";

export const GanttViewSwitcher = ({
  onViewModeChange,
  onViewListChange,
  isChecked,
  onUpdateGanttTask,
  showUpdateButtons,
  resetUpdatedTaskData,
}) => {
  return (
    <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: "15px" }}>
      {/* Left: Show Task List toggle + color legend */}
      <div className="d-flex align-items-center gap-3">
        <div className="Switch">
          <label className="Switch_Toggle me-2">
            <input
              type="checkbox"
              defaultChecked={isChecked}
              onClick={() => onViewListChange(!isChecked)}
            />
            <span className="Slider" />
          </label>
          {t("Show Task List")}
        </div>

        <div className="d-flex align-items-center gap-2" style={{ fontSize: "12px", color: "#6b7280" }}>
          {[
            { color: "#3b82f6", label: t("Pending") },
            { color: "#f59e0b", label: t("In Progress") },
            { color: "#a855f7", label: t("Testing") },
            { color: "#22c55e", label: t("Completed") },
            { color: "#ef4444", label: t("Overdue") },
          ].map(({ color, label }) => (
            <span key={label} className="d-flex align-items-center gap-1">
              <span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, backgroundColor: color, flexShrink: 0 }} />
              {label}
            </span>
          ))}
        </div>
      </div>

      {/* Right: view mode buttons + update buttons */}
      <div className="d-flex align-items-center gap-1">
        <button
          className="btn btn-gray align-items-center gap-1"
          onClick={() => onViewModeChange(ViewMode.Day)}
        >
          {t("Day")}
        </button>
        <button
          className="btn btn-gray align-items-center gap-1"
          onClick={() => onViewModeChange(ViewMode.Week)}
        >
          {t("Week")}
        </button>
        <button
          className="btn btn-gray align-items-center gap-1"
          onClick={() => onViewModeChange(ViewMode.Month)}
        >
          {t("Month")}
        </button>
        <button
          className="btn btn-gray align-items-center gap-1"
          onClick={() => onViewModeChange(ViewMode.Year)}
        >
          {t("Year")}
        </button>

        {showUpdateButtons ? (
          <div className="d-flex gap-2 ms-3">
            <button
              className="btn btn-primary"
              onClick={() => onUpdateGanttTask(true, false)}
            >
              {t("Change")}
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={() => onUpdateGanttTask(false, true)}
            >
              {t("Unlink")}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
